export default __webpack_public_path__ + "static/media/extension-feedback-number-1.6f172af9.svg";